export default __webpack_public_path__ + "static/visu-617bf677fd0533c0bd07aa7dbd5c7d10.jpg";